"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var DlgCloneBonusLocale = /** @class */ (function (_super) {
    __extends(DlgCloneBonusLocale, _super);
    function DlgCloneBonusLocale(props) {
        return _super.call(this, props) || this;
    }
    DlgCloneBonusLocale.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                currency_avail: data.currenciesAvail,
                currency_id: data.currency_id,
                currency_title: data.currency_title,
                language_avail: data.languagesAvail,
                language_id: data.language_id,
                language_title: data.language_title
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            currency_id: 0,
            currency_title: "",
            currency_avail: [],
            language_id: 0,
            language_title: "",
            language_avail: [],
        });
        this.doReSetRules();
    };
    DlgCloneBonusLocale.prototype.doReSetRules = function () {
        this.setState({
            currency_rules: { isError: false },
            language_rules: { isError: false }
        });
    };
    DlgCloneBonusLocale.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgCloneBonusLocale.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if (this.state.currency_id <= 0) {
            this.setState({
                currency_rules: {
                    isError: true,
                    errorMessage: "Поле [валюта] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.language_id <= 0) {
            this.setState({
                language_rules: {
                    isError: true,
                    errorMessage: "Поле [язык] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgCloneBonusLocale.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.currency_id, this.state.language_id);
            }
        }
    };
    DlgCloneBonusLocale.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgCloneBonusLocale.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 400 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.currency_id, value: this.state.currency_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            currency_id: newVal.key,
                            currency_title: newVal.value,
                            currency_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetCurrency(_this.state.currency_id, _this.state.currency_title);
                        });
                    }, items: this.state.currency_avail, required: true, rules: this.state.currency_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Локализация:", placeholder: "Выберите локализацию" }, value: { key: this.state.language_id, value: this.state.language_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            language_id: newVal.key,
                            language_title: newVal.value,
                            language_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetLanguage(_this.state.language_id, _this.state.language_title);
                        });
                    }, items: this.state.language_avail, required: true, rules: this.state.language_rules })));
    };
    return DlgCloneBonusLocale;
}(React.Component));
exports.default = DlgCloneBonusLocale;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgCloneBonusLocale.tsx
// module id = 2588
// module chunks = 0